import { useSelector } from "react-redux";
import { useRef, useState } from "react";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { successMessage } from "../../utils/toastify-message/ToastifyMessage";
import UserModal from "../../components/common/modals/user-modal/UserModal";
import { PiXFill } from "react-icons/pi";
import DateInput from "../../components/common/inputs/DateInput";

export default function UserReportsFilter({ filterDataHandler }) {
  const { utils } = useSelector(utilsState);
  const userModalRef = useRef();

  const [user, setUser] = useState(null);

  const handleUser = (data) => {
    setUser(data.name);
    successMessage(`کاربر ${data?.name} انتخاب شد`);
    filterDataHandler({ page: 1, user: data?._id });
  };

  const deleteUser = () => {
    setUser("");
    filterDataHandler({ page: 1, user: "" });
  };

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />

      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            نوع تراکنش
          </label>
          <div className="relative">
            <select
              onChange={(e) =>
                filterDataHandler({ page: 1, type: e.target.value })
              }
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
            >
              <option value={""}>همه</option>
              <option value={"deposit"}>واریز</option>
              <option value={"withdrawal"}>برداشت</option>
            </select>
            <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            کمیسیون
          </label>
          <div className="relative">
            <select
              onChange={(e) =>
                filterDataHandler({ page: 1, isCommission: e.target.value })
              }
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pl-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
            >
              <option value={""}>همه</option>
              <option value={"1"}>بله</option>
              <option value={"0"}>خیر</option>
            </select>
            <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <div className="relative w-full">
          <span
            onClick={() => userModalRef?.current?.showModal()}
            className="absolute w-full h-full cursor-pointer z-10"
          ></span>
          {user ? (
            <PiXFill
              className="cursor-pointer absolute left-2 bottom-4 text-red-500 z-20"
              onClick={deleteUser}
            />
          ) : null}
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            انتخاب کاربر
          </label>
          <input
            value={user || ""}
            onChange={(e) => setUser(e.target.value)}
            disabled
            placeholder="انتخاب کاربر"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 cursor-pointer"
          />
        </div>

        <div className="w-full">
          <DateInput
            label={"از تاریخ"}
            onChange={(e) => filterDataHandler({ page: 1, from: e })}
          />
        </div>

        <div className="w-full">
          <DateInput
            label={"تا تاریخ"}
            onChange={(e) => filterDataHandler({ page: 1, to: e })}
          />
        </div>
      </div>
    </div>
  );
}
